const PLATE_PATTERNS = {
  SE: /^[A-HJ-PR-UW-Z]{3}\d{2}[0-9A-HJ-NPR-UW-Z]$/,
  NO: /^[A-Z]{2}[1-9]\d{4}$/,
  DK: /^[A-Z]{2}\d{5}$/,
  FI: /^[A-Z]{2,3}[1-9]\d{0,2}$/,
  IS: /^[A-Z]{2}(?:\d{3}|[A-Z]\d{2})$/,
}

export const normalizeLicensePlate = value => (
  typeof value === 'string' ? value.toUpperCase().replace(/[\s-]/g, '') : ''
)

// A complete short plate can also be the start of another country's longer plate.
// For example, AB123 can grow into AB12345 and ABC12 into ABC123 or ABC12D.
export const getLicensePlateSearchDelay = value => (
  /^(?:[A-Z]{2}\d{1,3}|[A-Z]{3}\d{1,2})$/.test(normalizeLicensePlate(value)) ? 600 : 0
)

// Format detection only: the vehicle lookup still determines whether a plate exists.
export const isCompleteNordicLicensePlate = value => {
  const plate = normalizeLicensePlate(value)
  return Object.values(PLATE_PATTERNS).some(pattern => pattern.test(plate))
}
